/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';

const getToken = () =>{
    let payload = JSON.parse(sessionStorage.getItem('chatStorage'));
    return payload.user.token;
}

const getPublicMessages = async() =>{
    try {
        const response = await axios.get(`/message/getpublic`, {headers:{'Authorization': `Bearer ${getToken()}`}});
        return response.data;
    } catch (error) {
        return error;
    }
};

const getPrivateChat = async(author, dest) =>{
    try {
        const response = await axios.get(`/message/getprivate/${author}/${dest}`, {headers:{'Authorization': `Bearer ${getToken()}`}});
        return response.data;
    } catch (error) {
        return error;
    }
};

const deleteAllMessages = async () =>{
    try{
        const response = await axios.delete(`/message`, { headers:{ 'Authorization': `Bearer ${getToken()}` }});
        return response.data;
    }catch(error){
        return error;
    }
}

const uploadFileMessage = async(formData)=>{
    try{
        const response = await axios.post(`/message/upload`, formData, {headers:{
            'Authorization': `Bearer ${getToken()}`,
            "content-type" : 'multipart/form-data'
        }} )
        return response.data
    }catch(err){
        return err;
    }
}

export default { getPublicMessages, getPrivateChat, deleteAllMessages, uploadFileMessage };